module.exports = __webpack_public_path__ + "static/hero-f822668a225b63ef72641e897c5f0dff.svg";